import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import { getPropertyVendorsMap } from 'entities/Vendors';

import {
    ItemAvailabilityStatus,
    getItemAvailabilityStatus,
} from './itemAvailability';

export const useItemAvailability = (proposals: Proposal[] | undefined) => {
    const vendorsMap = useSelector(getPropertyVendorsMap);

    const availabilityStatus = useMemo(
        () => getItemAvailabilityStatus(proposals, vendorsMap),
        [proposals, vendorsMap],
    );

    const isAvailable = availabilityStatus === ItemAvailabilityStatus.AVAILABLE;

    return { availabilityStatus, isAvailable };
};
